import { WizardItemType } from '../Enums/WizardItemType.enum';
import { WizardItem, WizardRootItem } from '../Interfaces/Wizard.interface';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { useMemo } from 'react';

export default function useWizardForm(activeStep: WizardRootItem | null) {
	const handleType = (type: WizardItemType, parentType?: WizardItemType) => {
		if (parentType === WizardItemType.SELECT) {
			return undefined;
		}
		return type;
	};

	const removeNullUndefined = (obj: Record<string, unknown>) => {
		for (const key in obj) {
			if (obj[key] === null || obj[key] === undefined) {
				delete obj[key];
			}
		}
		return obj;
	};

	const generateFormScheme = (
		wizardItems: WizardItem[],
		parentType?: WizardItemType,
	): ItemScheme[] => {
		const formScheme: ItemScheme[] = [];
		wizardItems.forEach(item => {
			const newItem = {
				key: item.key,
				value: item.value,
				title: item.title,
				subType: item.subtype,
				type: handleType(item.type, parentType),
				defaultValue: item.settings?.defaultValue,
				settings: { ...item.settings, submitData: item.data },
				children:
					item.children && item.children.length > 0
						? generateFormScheme(item.children, item.type)
						: undefined,
			};
			formScheme.push(removeNullUndefined(newItem) as ItemScheme);
		});
		return formScheme;
	};

	const formScheme = useMemo(() => {
		if (!activeStep) return;
		return generateFormScheme(activeStep.children);
	}, [activeStep]);

	const defaultValues = useMemo(() => {
		if (!activeStep?.settings?.defaultData) return;
		return activeStep.settings.defaultData;
	}, [activeStep]);

	return {
		formScheme,
		defaultValues,
	};
}
